
const vFilters = {
      /**
   * 功能：{el-input}全局限制只可输入数字最大俩位小数
   * @param decimal //小数位置默认2位
   */
    verifyDigitThree: (el, binding,vnode) =>  {   
        el.addEventListener('input', function(e) {
            // 限制只能输入数字和小数点
           let value = e.target.value.replace(/[^\d.]/g, '');
            // 限制只能有一个小数点
            const dotIndex = value.indexOf('.');
            if (dotIndex !== -1) {
                value = value.substring(0, dotIndex + 1) + value.substring(dotIndex + 1).replace(/\./g, '');
            }
            
            // 限制格式为0.xxx
            if (value.startsWith('0') && value.length > 1 && value[1] !== '.') {
                value = '0.' + value.substring(1);
            }
            
            // 限制最大输入长度和精度
            if (dotIndex !== -1 && value.length > dotIndex + 4) {
                value = value.substring(0, dotIndex + 4);
            }
            console.log(value);
            vnode.componentInstance.$emit('input', value);
        })
    },
    verifyDigitTwo: (el, binding,vnode) =>  {
            let decimal= binding.value||3; 
            console.log(decimal);   
            el.addEventListener('input', function(e) {
                // 限制只能输入数字和小数点
            let value = e.target.value.replace(/[^\d.]/g, '');
                // 限制只能有一个小数点
                const dotIndex = value.indexOf('.');
                if (dotIndex !== -1) {
                    value = value.substring(0, dotIndex + 1) + value.substring(dotIndex + 1).replace(/\./g, '');
                }
                
                // 限制格式为0.xxx
                if (value.startsWith('0') && value.length > 1 && value[1] !== '.') {
                    value = '0.' + value.substring(1);
                }
                
                // 限制最大输入长度和精度
                if (dotIndex !== -1 && value.length > dotIndex + decimal) {
                    value = value.substring(0, dotIndex + decimal);
                }
                vnode.componentInstance.$emit('input', value);
        })
    },
         // el表格挂载左右滑动
    tabelMove(el, binding, vnode) {
      var odiv = el // 获取当前表格元素
      console.log(el)
      el.querySelector('.el-table .el-table__body-wrapper').style.cursor = 'pointer'
      var mouseDownAndUpTimer = null
      var mouseOffset = 0
      var mouseFlag = false
      odiv.onmousedown = (e) => {
        const ePath = composedPath(e)
        // 拖拽表头不滑动
        if (ePath.some(res => { return res && res.className && res.className.indexOf('el-table__header') > -1 })) return
 
        if (e.which !== 1) return
 
        mouseOffset = e.clientX
        mouseDownAndUpTimer = setTimeout(function() {
          mouseFlag = true
        }, 80)
      }
      odiv.onmouseup = (e) => {
        setTimeout(() => {
          // vnode.context:当前的vm实例 -- 渲染表格
          vnode.context.$refs.orderTable && vnode.context.$refs.orderTable.doLayout()
        }, 200)
        if (mouseFlag) {
          mouseFlag = false
        } else {
          clearTimeout(mouseDownAndUpTimer) // 清除延迟时间
        }
      }
      odiv.onmouseleave = (e) => {
        setTimeout(() => {
          // vnode.context:当前的vm实例 --  渲染表格
          vnode.context.$refs.orderTable && vnode.context.$refs.orderTable.doLayout()
        }, 200)
        mouseFlag = false
      }
      odiv.onmousemove = (e) => {
        if (e.which !== 1) return
 
        const divData = odiv.querySelector('.el-table .el-table__body-wrapper')
        if (mouseFlag && divData) {
          // 设置水平方向的元素的位置
          divData.scrollLeft -= (-mouseOffset + (mouseOffset = e.clientX))
        }
      }
      // 解决有些时候,在鼠标松开的时候,元素仍然可以拖动;
      odiv.ondragstart = (e) => {
        e.preventDefault()
      }
      odiv.ondragend = (e) => {
        e.preventDefault()
      }
    // 点击复制
      odiv.onclick = (e) => {
        console.log(e);
          setTimeout(() => {
        if (mouseFlag) return
        let tableRow
        // 点击给背景颜色
        // if (e.path && e.path.length) {
        //   e.path.forEach(element => {
        //     if (element.classList && element.classList.length) {
        //       if (element.classList.contains('el-table__row')) {
        //         tableRow = element
        //       }
        //       if (element.classList.contains('el-table__body')) {
        //         if (element.childNodes && element.childNodes.length) {
        //           element.childNodes.forEach(item => {
        //             if (item.nodeName === 'TBODY') {
        //               item.childNodes.forEach(inds => {
        //                 if (tableRow) {
        //                   if (tableRow === inds) {
        //                     !tableRow.classList.contains('success-row') ? tableRow.classList.add('success-row') : tableRow.classList.remove('success-row')
        //                   } else {
        //                     inds && inds.classList && inds.classList.contains('success-row') ? inds.classList.remove('success-row') : ''
        //                   }
        //                 }
        //               })
        //             }
        //           })
        //         }
        //       }
        //     }})}

      // 点击复制
        console.log(e.target.nodeName); 
          if (e.target.nodeName === 'SPAN') {
            console.log(mouseFlag, e.target.nodeName, this)
            var aux = document.createElement('input')
            aux.setAttribute('value', e.target.outerText)
            document.body.appendChild(aux)
            aux.select()
            document.execCommand('copy')
            document.body.removeChild(aux)
            if (document.execCommand('copy')) {
               console.log('复制成功')
            } else {
              console.log('复制失败')
            }
          }
        }, 300)
      }
      // 是否选中文字
      odiv.onselectstart = () => {
        return false
      }
      function composedPath(e) {
        // 存在则直接return
        if (e.path) { return e.path }
        // 不存在则遍历target节点
        let target = e.target
        e.path = []
        while (target.parentNode !== null) {
          e.path.push(target)
          target = target.parentNode
        }
        // 最后补上document和window
        e.path.push(document, window)
        return e.path
      }
    },
    // beforeUnmount(el) {
    //     // 清理事件监听器
    //     el.removeEventListener('input');
    // }
}

export default vFilters;
